<template>
    <svg width="45" height="50" viewBox="0 0 45 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="40" height="40" rx="13.75" fill="#2B7DC0"></rect>
        <rect x="3.5" y="3.5" width="33.125" height="33.125" rx="10.31" stroke="white" stroke-width="1.5"></rect>
        <path d="M0 23.5417V0H10.2328C12.4614 0 14.261 0.733283 15.6317 2.19985C16.9814 3.67736 17.6563 5.53246 17.6563 7.76514C17.6563 10.0635 16.9814 11.9514 15.6317 13.4289C14.261 14.9283 12.4614 15.678 10.2328 15.678H5.05361V23.5417H0ZM5.05361 10.9664H9.22834C11.4151 10.9664 12.5085 9.89932 12.5085 7.76514C12.5085 6.75824 12.2207 5.98665 11.6453 5.45037C11.0594 4.93598 10.2537 4.67878 9.22834 4.67878H5.05361V10.9664Z" fill="white" transform="translate(11, 8)"></path>
        <circle cx="31" cy="37" r="13" :fill="color"></circle>
        <path d="M34.8 31.8C35.2 31.8 35.55 32.07 35.67 32.45L37 36.2V41.2C37 41.55 36.72 41.83 36.37 41.83H35.72C35.37 41.83 35.09 41.55 35.09 41.2V40.55H26.91V41.2C26.91 41.55 26.63 41.83 26.28 41.83H25.63C25.28 41.83 25 41.55 25 41.2V36.2L26.33 32.45C26.45 32.07 26.8 31.8 27.2 31.8H34.8ZM26.28 36.4V39.4H35.72V36.4L35.64 36.2H26.36L26.28 36.4ZM27.8 36.85C28.34 36.85 28.77 37.28 28.77 37.82C28.77 38.36 28.34 38.79 27.8 38.79C27.26 38.79 26.83 38.36 26.83 37.82C26.83 37.28 27.26 36.85 27.8 36.85ZM34.2 36.85C34.74 36.85 35.17 37.28 35.17 37.82C35.17 38.36 34.74 38.79 34.2 38.79C33.66 38.79 33.23 38.36 33.23 37.82C33.23 37.28 33.66 36.85 34.2 36.85ZM26.7 34.65H35.3L34.63 32.65H27.37L26.7 34.65Z" fill="white"></path>
    </svg>
</template>
<script>
const parkingIcon = {
    name: 'parkingIcon',
    props: {
        color: {
            type: String,
            default: '#1A2653',
        },
    },
}
export default parkingIcon
export { parkingIcon }
</script>